const STEALTH: {[key: number]: string} = {
    1: "Bad",
    1.5: "Mediocre",
    2: "Good",
    2.5: "Exceptional"
}

export function displayStealth(stealth: number) {
  // if below between thresholds return the lower threshold

  const stealthValues = Object.keys(STEALTH).map((key) => Number(key)).sort();
  const maxStealth = stealthValues[stealthValues.length - 1];
  if (maxStealth !== undefined && stealth > maxStealth) {
    const maxLabel = STEALTH[maxStealth];
    if (maxLabel !== undefined) {
      return `${maxLabel} (${stealth})`;
    }
  }

  for (let i = 0; i < stealthValues.length; i++) {
    const currentValue = stealthValues[i];
    if (currentValue !== undefined && stealth < currentValue) {
      if(i === 0) {
        return `Bad (${stealth})`;
      }

      const prevValue = stealthValues[i - 1];
      if (prevValue !== undefined) {
        const prevLabel = STEALTH[prevValue];
        if (prevLabel !== undefined) {
          return `${prevLabel} (${stealth})`;
        }
      }
    }
  }

  const exactMatch = STEALTH[stealth];
  return exactMatch !== undefined ? exactMatch : String(stealth);
}

